module.exports = __webpack_public_path__ + "img/Katia.9d7216f0.jpg";